import { render, staticRenderFns } from "./claimDetail.vue?vue&type=template&id=54363e2c&scoped=true"
import script from "./claimDetail.vue?vue&type=script&lang=js"
export * from "./claimDetail.vue?vue&type=script&lang=js"
import style0 from "./claimDetail.vue?vue&type=style&index=0&id=54363e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54363e2c",
  null
  
)

export default component.exports